module.exports = __webpack_public_path__ + "img/australia-mental-and-behavioural-disorders-male.1fbd0583.png";